module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-view"
  }, [(_vm.isComplete) ? [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册成功")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "onsubmit": "return false"
    }
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("请复制以下Token进行登录")]), _vm._v(" "), _c('div', {
    staticClass: "form-alias"
  }, [_c('label', [_c('strong', [_vm._v("token")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "type": "text",
      "name": "token",
      "placeholder": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit"
  }, [_c('router-link', {
    staticClass: "submit",
    attrs: {
      "to": {
        name: 'LoginView'
      },
      "tag": "button"
    }
  }, [_vm._v("\n          去登录\n        ")])], 1)])] : [_c('h1', {
    staticClass: "title"
  }, [_vm._v("欢迎加入豆瓣")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit()
      }
    }
  }, [(_vm.error) ? _c('p', {
    staticClass: "tip error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-alias"
  }, [_c('label', [_c('strong', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-pwd"
  }, [_c('label', [_c('strong', [_vm._v("请输入密码")]), _vm._v(" "), (_vm.passType === 'password') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.pass),
      expression: "pass",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "name": "pass",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.passType === 'text') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.pass),
      expression: "pass",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "pass",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    class: {
      show: _vm.isShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-name"
  }, [_c('label', [_c('strong', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit"
  }, [_c('button', {
    staticClass: "submit",
    class: {
      disabled: _vm.isDisabled
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("\n          " + _vm._s(_vm.registerState) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "agreement"
  }, [_vm._v("点击「注册」代表你已阅读并同意用户使用协议")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("下载豆瓣App")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e60fb580"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RegisterView.vue
// module id = 209
// module chunks = 0